/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { cn } from "tailwind-variants";
import { useI18n } from "intl/useI18n";
import { useDtfStore } from "./store";
import "./Summary.scss";
import { renderList } from "common/vue/render-list";

export default function Summary({ ...restProps }) {
  const { n } = useI18n();
  const dtfStore = useDtfStore();

  function orderTotal() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return Number(dtfStore.summary.orderTotal);
  }

  function bulkDiscount() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return Number(dtfStore.summary.bulkDiscount);
  }

  function orderSubtotal() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return Number(dtfStore.summary.orderSubtotal);
  }

  function uploadedCount() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.artworks.filter(({ uploadError }: any) => !uploadError).length;
  }

  function enhancements() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return Object.values(dtfStore.summary.enhancements || []);
  }

  function artworksReady() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return dtfStore.artworks.every(
      (artwork: any) => !artwork.isLoading && artwork.enhancementCompleted
    );
  }

  function enableAbAiMonetization() {
    // @ts-expect-error TS(4111): Property 'enableAbAiMonetization' comes from an in... Remove this comment to see the full error message
    return dtfStore.enableAbAiMonetization;
  }

  function isBogoApplicable() {
    // @ts-expect-error TS(4111): Property 'isBogoApplicable' comes from an index si... Remove this comment to see the full error message
    return dtfStore.isBogoApplicable;
  }

  function getBogoAdjustedPrice() {
    // @ts-expect-error TS(4111): Property 'getBogoAdjustedPrice' comes from an inde... Remove this comment to see the full error message
    return dtfStore.getBogoAdjustedPrice;
  }

  function bogoInfo() {
    if (!isBogoApplicable()) {
      return {
        freeQty: 0,
        discount: 0
      };
    }
    let freeQty = 0;
    let discountAmount = 0;
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    dtfStore.artworks.forEach((artwork: any) => {
      const artworkId = String(artwork.id ?? "");
      const sizesAndQuantities = artwork.sizesAndQuantities ?? [];
      sizesAndQuantities.forEach((item: any) => {
        const sizeKey = `${item.width}x${item.height}`;
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        const bogoPrice = getBogoAdjustedPrice()(artworkId, item.id, sizeKey);
        if (bogoPrice && bogoPrice.freeQty > 0) {
          freeQty += bogoPrice.freeQty;
          const itemOriginalTotal = Number(item.unitPrice || 0) * item.quantity;
          discountAmount += itemOriginalTotal - bogoPrice.discountedTotalPrice;
        }
      });
    });
    return {
      freeQty,
      discount: discountAmount
    };
  }

  return (
    // @ts-expect-error TS(4111): Property 'className' comes from an index signature... Remove this comment to see the full error message
    <div {...restProps} className={cn("summary scope-f43cfb41", restProps.className)}>
      <h3 className="summary__title scope-f43cfb41">Summary</h3>
      <div className="summary__wrapper scope-f43cfb41">
        {/* @ts-expect-error TS(4111): Property 'isPricingLoading' comes from an index si... Remove this comment to see the full error message */}
        {enableAbAiMonetization() && (dtfStore.isPricingLoading || !artworksReady()) ? (
          <div className="summary__skeleton scope-f43cfb41">
            <div className="summary__skeleton-block scope-f43cfb41" />
            <div className="summary__skeleton-block scope-f43cfb41" />
            <div className="summary__skeleton-block scope-f43cfb41" />
            <div className="summary__skeleton-block scope-f43cfb41" />
            <div className="summary__skeleton-block summary__skeleton-block--last scope-f43cfb41" />
          </div>
        ) : (
          <>
            <div className="summary__row scope-f43cfb41">
              <div className="summary__label scope-f43cfb41">Designs uploaded:</div>
              <div className="summary__value scope-f43cfb41">{uploadedCount()}</div>
            </div>
            {orderTotal() ? (
              <div className="summary__row scope-f43cfb41">
                <div className="summary__label scope-f43cfb41">Order total:</div>
                <div className="summary__value scope-f43cfb41">{n(orderTotal(), "currency")}</div>
              </div>
            ) : null}
            {renderList(enhancements(), enhancement => (
              <div className="summary__row scope-f43cfb41" key={enhancement.serviceName}>
                {Number(enhancement.totalPrice) > 0 ? (
                  <>
                    <div className="summary__label scope-f43cfb41">
                      {enhancement.quantity} {enhancement.serviceName}:{" "}
                    </div>
                    <div className="summary__value scope-f43cfb41">
                      {n(enhancement.totalPrice, "currency")}
                    </div>
                  </>
                ) : null}
              </div>
            ))}
            {bulkDiscount() ? (
              <div className="summary__row summary__row--bulk scope-f43cfb41">
                <div className="summary__label scope-f43cfb41">Bulk discount:</div>
                <div className="summary__value scope-f43cfb41">
                  -{n(bulkDiscount(), "currency")}
                </div>
              </div>
            ) : null}
            {bogoInfo().freeQty > 0 ? (
              <div className="summary__row summary__row--bogo scope-f43cfb41">
                <div className="summary__label scope-f43cfb41">
                  {bogoInfo().freeQty} FREE {bogoInfo().freeQty === 1 ? "Transfer" : "Transfers"}
                  :{" "}
                </div>
                <div className="summary__value scope-f43cfb41">
                  -{n(bogoInfo().discount, "currency")}
                </div>
              </div>
            ) : null}
            {orderSubtotal() || bogoInfo().freeQty > 0 ? (
              <div className="summary__row summary__row--subtotal scope-f43cfb41">
                <div className="summary__label scope-f43cfb41">Subtotal</div>
                <div className="summary__value scope-f43cfb41">
                  {n(
                    bogoInfo().freeQty > 0
                      ? orderSubtotal() - bogoInfo().discount
                      : orderSubtotal(),
                    "currency"
                  )}
                </div>
              </div>
            ) : null}
            {bogoInfo().discount > 0 ? (
              <div className="summary__row summary__row--savings scope-f43cfb41">
                <div className="summary__label scope-f43cfb41" />
                <div className="summary__value summary__savings scope-f43cfb41">
                  {" "}
                  You save {n(bogoInfo().discount + bulkDiscount(), "currency")}!{" "}
                </div>
              </div>
            ) : null}
          </>
        )}
      </div>
    </div>
  );
}
